import { DefaultPathEnum } from '../../main/constants/default-path.ts';
import { RootState } from '../../main/store/main.store.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

export const selectUnauthenticatedRedirectionPath = createMemoizedSelector(
  (state: RootState) => state.auth.hasUserSignedIn,
  (hasUserSignedIn): DefaultPathEnum => {
    return hasUserSignedIn ? DefaultPathEnum.AUTH_SIGN_IN_SCREEN : DefaultPathEnum.AUTH_SIGN_UP_SCREEN;
  }
);
